<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <!-- Stylized Y with a coffee-bean O inspired by the Yoshan logo -->
  <!-- Y letterform -->
  <path d="M2 4L7 12L7 20" />
  <path d="M12 4L7 12" />
  <!-- O with coffee bean notch (the distinctive Yoshan logo element) -->
  <circle cx="18" cy="12" r="5.5" />
  <path d="M16.5 8C17.5 10 17.5 14 16.5 16" />
</svg>
